import { render } from "./ThresholdSettings.vue?vue&type=template&id=22c7faa6&scoped=true"
import script from "./ThresholdSettings.vue?vue&type=script&lang=js"
export * from "./ThresholdSettings.vue?vue&type=script&lang=js"

import "./ThresholdSettings.vue?vue&type=style&index=0&id=22c7faa6&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c7faa6"]])

export default __exports__